<template>
  <div>
    <ChatBoxTitle>
      <div slot="left">
        <img src="../img/back.svg" style="cursor: pointer;" @click="() => { $emit('close'); logout() }" alt="Close">
        <!-- <img src="../img/back.svg" @click="$emit('openMenu', false)" alt="back"> -->
      </div>
      <div slot="center">
        Admin Panel
        <!-- <a class="title-link" target="_blank" :href="`https://yoteachapp.com/room/${room._id}`" v-if="room && room.title">{{ room.title }}</a> -->
      </div>
      <div slot="right">
      </div>
    </ChatBoxTitle>

    <div class="marginer">
      <div class="padding">
        <div class="tab-row">
          <div class="tab-icon" :class="{ active: tab === 'reports' }" @click="tab = 'reports';">
            Reported Messages
          </div>
          <div class="tab-icon" :class="{ active: tab === 'rooms' }" @click="tab = 'rooms';">
            Rooms
          </div>
        </div>
        <div class="tab-content" v-if="tab === 'reports'">
          <AdminReports @showChat="showChat" :earthID="earthID" :userID="userID"></AdminReports>
        </div>
        <div class="tab-content" v-if="tab === 'rooms'">
          <AdminRooms  :earthID="earthID" :userID="userID"></AdminRooms>
        </div>
      </div>
    </div>

    <!-- <TabBar @bar="(v) => { $emit('bar', v) }"></TabBar> -->
  </div>
</template>

<script>
// import TabBar from './TabBar.vue'
import ChatBoxTitle from './ChatBoxTitle.vue'
import { API } from '@/yoteach2-gui/parts/index.js'
import * as eAPI from './eAPI.js'
// import { API } from '@/yoteach2-gui/parts/index.js'

export default {
  API,
  props: {
    earthID: {},
    userID: {}
  },
  components: {
    // TabBar,
    AdminReports: () => import('./AdminReports.vue'),
    AdminRooms: () => import('./AdminRooms.vue'),
    ChatBoxTitle
  },
  data () {
    return {
      tab: 'reports',
      errLogin: '',
      auth: {
        username: '',
        password: ''
      }
    }
  },
  mounted () {
    if (!eAPI.check()) {
      this.$emit('overlay', '')
    }
  },
  methods: {
    async showChat ({ roomID }) {
      // let resp = await API.getRoom({ _id: roomID })
      // this.$emit('currentRoom', resp.data)
      // this.$emit('overlay', '')
      // this.$emit('main', 'chat')
      // this.$emit('bar', 'earthcourse')
    },
    logout () {
      eAPI.logout()
    }
  }
}
</script>

<style scoped>
.all-center{
  display: flex;
  justify-content: center;
  align-items: center;
}
.marginer{
  padding: 1px;
  height: calc(100% - 2px);
  width: calc(100% - 2px);
}
.padding{
  padding: 20px;
}
.tab-row{
  display: flex;
}
.tab-icon{
  display: inline-block;
  padding: 10px 20px;
  /* border: rgba(185, 40, 40, 1.0) solid 1px; */
  margin: 0px 10px;

  border-radius: 15px;
  border: #a71524 solid 1px;
  color: #a71524;

  /* color: rgb(185, 40, 40); */
}
.tab-icon.active{
  background-image: linear-gradient(-90deg, #a71524, hsl(0, 83%, 41%), #f73c3c);
  color: white;
}
.tab-content{
  border-top: rgb(185, 2, 2) solid 1px;
  padding: 20px;
  margin: 10px;
  margin-top: 25px;
}
</style>
